import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useSearchParams } from 'react-router-dom';
import { Page } from '@/components/Ui/Page';
import { PageHeader } from '@/components/Ui/PageHeader';
import { useOidcRefreshOnReturn } from '@/hooks/useOidcRefreshOnReturn';
import { useScrollToSection } from '@/hooks/useScrollToSection';
import { useRustyState } from '@/state';
import { DataPrivacy } from './DataPrivacy';
import { Preferences } from './Preferences';
import { SignInHistory } from './SignInHistory';
import { SignInMethods } from './SignInMethods';
import { TwoStepSection } from './TwoStepSection';

export function SecurityScreen() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const location = useLocation();
  const session = useRustyState((s) => s.api?.auth?.getSession());
  const auth = useRustyState((s) => s.api?.auth);

  // Back from the GoFranz portal with ?refreshed=1: re-read the profile from the IdP.
  useOidcRefreshOnReturn({ session, auth });

  useEffect(() => {
    if (!useRustyState.getState().formsSummary) void useRustyState.getState().refreshFormsSummary();
  }, []);

  // Old links (/account/security-log, /account/data-privacy) land here with ?section=.
  const section = params.get('section');
  useScrollToSection(section === 'history' || section === 'data' ? section : null, location.key);

  return (
    <Page width="narrow">
      <PageHeader title={t('security.pageTitle')} />
      <SignInMethods />
      <TwoStepSection />
      <SignInHistory />
      <Preferences />
      <DataPrivacy />
    </Page>
  );
}
